import { useContext, useState } from "react";
import { IPayloadCreateFollowUpRequest } from "../../../../types";
import { useDirectusApi } from "../../../../libs/data-access";
import { showToast } from "../../../../utils/utility";
import { IPatientUpcomingFollowup } from "../../../../libs/data-access/types";
import { AppContext } from "../../../../AppContext";
import usePatientList from "../../../patientForms/PatientsBaseLine/hook/usePatientList";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { API } from "../../../../libs/data-access/constant";

export default function useAdminPatients() {
  const [searchParams] = useSearchParams();
  const { user } = useContext(AppContext);
  const { postDirectData } = useDirectusApi();
  const centerId = searchParams.get("center_id");
  const centerRoleID = user?.role?.name === "Center" ? user?.id : centerId ? centerId : "";

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [filterValue, setFilterValue] = useState<string>("");
  const [isFollowUpModalOpen, setIsFollowUpModalOpen] = useState(false);
  const [upcomingFollowup, setUpcomingFollowup] = useState<IPatientUpcomingFollowup[]>([]);
  const [selectedPatient, setSelectedPatient] = useState<IPatientUpcomingFollowup>({} as IPatientUpcomingFollowup);
  const [payloadForAddFollowUpRequest, setPayloadForAddFollowUpRequest] =
    useState<IPayloadCreateFollowUpRequest>({
      followup_date: new Date(),
      patient_id: "",
      remarks: "",
    });


  const handleUpdatePayload = (
    e: keyof IPayloadCreateFollowUpRequest | "all",
    value: any
  ) => {
    if (e === "all") {
      setPayloadForAddFollowUpRequest(value)
    } else {
      setPayloadForAddFollowUpRequest((prev) => ({ ...prev, [e]: value }));
    }
  };

  const handleAddFollowUpRequest = async (parentId?: string) => {
    let payload: IPayloadCreateFollowUpRequest = {
      ...payloadForAddFollowUpRequest,
      patient_id: parentId ? parentId : "" + selectedPatient?.id,
    };

    const res = await postDirectData(`items/follow_up`, payload);
    if (res?.isSuccess) {
      showToast({
        type: "success",
        title: "Successfully",
        message: "Tele Followup request added successfully",
      });
      handleGetUpcomingPatientList(currentPage, centerRoleID);
      setIsFollowUpModalOpen(false);
    } else {
      showToast({
        type: "error",
        title: "Error",
        message:
          res?.message ||
          "Error encountered while adding  Tele Followup request.",
      });
    }
  };

  const handleGetUpcomingPatientList = async (cp: number, centerRoleID: string, filterValue?: string) => {
    setIsLoading(true);
    const newOffset = cp || currentPage
    axios
      .get(`${API}custom/patient-list/upcoming-followup?center_id=${centerRoleID}&offset=${newOffset}&limit=10${filterValue ? `&searchText=${filterValue}` : ""}`)
      .then((res) => {
        console.log(res.data.data)
        if (res.data) {
          setUpcomingFollowup(res.data.data)
        }
      })
      .catch((err) => {
        setUpcomingFollowup([])
        console.log("Error in fetching stats", err);
      });
    setIsLoading(false);
  };

  return {
    isLoading,
    filterValue,
    setFilterValue,
    totalPage,
    currentPage,
    setCurrentPage,
    payloadForAddFollowUpRequest,
    selectedPatient,
    isFollowUpModalOpen,
    patientList: upcomingFollowup,
    setIsFollowUpModalOpen,
    setSelectedPatient,
    handleUpdatePayload,
    handleAddFollowUpRequest,
    handleGetPatientList: handleGetUpcomingPatientList,
    centerRoleID
  };
}
